var segmentedControlItem = 'fx_c76f37be_1an4y3q0';
var segmentedControlItemClickable = 'fx_c76f37be_1an4y3q1';

export { segmentedControlItem, segmentedControlItemClickable };
//# sourceMappingURL=item.vanilla.mjs.map
